export default "/_next/static/images/HeartIcon-f17a16def857a21916821f4083a3ceeb.svg";